import { ContextMenuDesignTokens } from '@primeuix/themes/aura/contextmenu';

export const contextMenuTokens: ContextMenuDesignTokens = {
  root: {
    background: '{content.background}',
    borderColor: '{content.border.color}',
    borderRadius: '{content.border.radius}',
    color: '{content.color}',
    shadow: '{overlay.navigation.shadow}',
    transitionDuration: '{transition.duration}',
  },
  list: {
    padding: '{navigation.list.padding}',
    gap: '{navigation.list.gap}',
  },
  item: {
    focusBackground: '{navigation.item.focus.background}',
    focusColor: '{navigation.item.focus.color}',
    activeBackground: '{navigation.item.active.background}',
    activeColor: '{navigation.item.active.color}',
    color: '{navigation.item.color}',
    padding: '{navigation.item.padding}',
    borderRadius: '{navigation.item.border.radius}',
    gap: '{navigation.item.gap}',
    icon: {
      color: '{navigation.item.icon.color}',
      focusColor: '{navigation.item.icon.focus.color}',
      activeColor: '{navigation.item.icon.active.color}',
    },
  },
  submenuIcon: {
    size: '{navigation.submenu.icon.size}',
    color: '{navigation.submenu.icon.color}',
    focusColor: '{navigation.submenu.icon.focus.color}',
    activeColor: '{navigation.submenu.icon.active.color}',
  },
  submenu: {
    mobileIndent: '1rem',
  },
  separator: {
    borderColor: '{content.border.color}',
  },
};
